import { render, staticRenderFns } from "./LightBulb.vue?vue&type=template&id=099127b2&"
import script from "./LightBulb.vue?vue&type=script&lang=js&"
export * from "./LightBulb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports